










import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CircleText extends Vue {
  @Prop()
  public text?: string

  @Prop()
  public color?: string

  public get myStyle (): string {
    if (this.color) {
      return 'border-color: ' + this.color.toString() + '; color: ' + this.color.toString()
    }
    return ''
  }
}
